fx.ns("filters.photofilters", class BaseFilter {
    
    constructor(parameters)
    {
        this.elements = [];

        this._id = parameters.id;

        this._label = parameters.label;
        this._thumb = parameters.thumb;
        this._params = parameters.params;
    }

    get elementsList(){
        return this.elements;
    }

    get id(){
        return this._id;
    }

    get label(){
        return this._label;
    }

    get thumb(){
        return this._thumb;
    }

    get params(){
        return this._params;
    }

  
    apply(SVGElement)
    {
        this.clear();

        this.SVGElement = SVGElement;
        
        if (this.filterFCN)
        {
            this.filterFCNHandler = this.filterFCN.bind(this);

            let filter = SVGElement.filter(this.filterFCNHandler);

            this.elements.push(filter);
        }
	}

    addFilter(filter, SVGElement)
    {
        this.SVGElement = SVGElement;
        
        if (this.filterFCN)
            return this.filterFCN(filter);

        //return this.filterFCNHandler(filter);
    }

    resize(width, height)
    {
       
    }

    move(x, y)
    {
       
    }
      
	clear()
	{
        for (let i = 0; i < this.elements.length; i++)
            this.elements[i].remove();
                
        this.elements = [];

        if (this.SVGElement)
        {
            this.SVGElement.unfilter(true);
            this.SVGElement.attr("filter", null);
        }

        this.filterFCNHandler = null;
        this.SVGElement = null;
	}

    

});
